import React, { useCallback, useMemo } from 'react';
import { changeUserCompany } from 'src/store/actions/userActions';
import DropDownSelector from '../Inputs/DropDownSelector';
function CompaniesSelector({ options, companyId, className }) {
    const onCompanySelect = useCallback((option) => {
        if (!companyId || option !== companyId) {
            changeUserCompany(option);
        }
    }, [companyId]);
    const companiesOptions = useMemo(() => options.map(({ Name, Id }) => ({
        label: Name,
        value: `${Id}`
    })), [options]);
    return (React.createElement(DropDownSelector, { options: companiesOptions, values: companyId ? [companyId] : [], onSelect: onCompanySelect, isSingleSelect: true, filterEnabled: true, className: className }));
}
export default CompaniesSelector;
